<div class="modal-header acm-header">
  <h5 class="modal-title acm-title">
    <i class="las la-sliders-h mr-2"></i>{{ 'home.taggingKpiConfigTitle' | translate }}
  </h5>
  <button type="button" class="close" (click)="dismiss()"><span>&times;</span></button>
</div>

<div class="modal-body acm-body">
  <div class="acm-section">
    <label class="acm-label mb-0">{{ 'home.taggingKpiConfigSubtitle' | translate }}</label>
    <div class="acm-types-hint">{{ 'home.taggingKpiConfigHint' | translate }}</div>

    <div class="acm-types-list mt-2">
      <label
        *ngFor="let t of availableTypes"
        class="acm-type-item"
        [class.acm-type-item--selected]="isSelected(t)"
        (click)="toggleType(t)"
      >
        <span class="acm-checkbox">
          <i class="las" [class.la-check-square]="isSelected(t)" [class.la-square]="!isSelected(t)"></i>
        </span>
        <span>
          <span class="acm-type-name d-block">{{ 'howApplied.' + t.toLowerCase() + '.label' | translate }}</span>
          <span class="acm-type-desc">{{ 'howApplied.' + t.toLowerCase() + '.description' | translate }}</span>
        </span>
      </label>
    </div>
  </div>
</div>

<div class="modal-footer acm-footer">
  <button class="btn btn-sm btn-outline-secondary mr-auto" (click)="reset()">
    <i class="las la-undo mr-1"></i>{{ 'home.taggingKpiConfigReset' | translate }}
  </button>
  <button class="btn btn-sm btn-outline-dark" (click)="dismiss()">{{ 'home.taggingKpiConfigCancel' | translate }}</button>
  <button class="btn btn-sm btn-primary" (click)="apply()">
    <i class="las la-check mr-1"></i>{{ 'home.taggingKpiConfigApply' | translate }}
  </button>
</div>
